import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Drawer from '@blade/common/components/task-management/paint.vue';
import mapUtil from '@blade-sxp/map-new/index.vue';
import { FictitiousMapModule } from '@blade-sxp/task-management/store/fictitiousMap';
import MapLoading from './map-loading.vue';
import { cloneDeep, isEmpty } from 'lodash';
import { Scale } from '@blade/common/utils/auto-scale';
import MapLocationLabel from '@blade/common/components/map-doms/location-label.vue';
import { EVENT_KEY } from '@blade-sxp/task-management/interfaces/index';
import { TaskMangementModule as store } from '@blade-sxp/task-management/store/index';
import { getIconVisibleDistance } from '@blade-sxp/screen/api/build-information';
import { initEntranceExitDataConfig } from '@blade-sxp/task-management/config/createTaskConfig';
const Service = {
    getIconVisibleDistance,
};
const ICON = {
    exit: require('@blade-sxp/task-management/assets/icon/exit.png'),
    exitLighHight: require('@blade-sxp/task-management/assets/icon/exitHight.png'),
    entrance: require('@blade-sxp/task-management/assets/icon/entrance.png'),
    entranceLighHight: require('@blade-sxp/task-management/assets/icon/entranceHight.png'),
};
let DrawMap = class DrawMap extends Vue {
    buttons;
    limits;
    isPlayFlag;
    showSelect;
    directionConfig;
    specifiedStyle;
    options;
    styleProp;
    mapImageUrl;
    mapType;
    loading;
    isRootNode;
    mapName;
    entranceExitData; // 是否是进出口
    isTotalArea; // 是否是总区域
    mainAngle; // 主视角
    heatMapList = [];
    // mapDataloading: boolean = false;
    interactEnable = false;
    // progress: number = 0;
    iconList = [];
    eventData = {};
    cursor = ''; // markIcon
    tips = '';
    isShowSelectDirectionAlert = false;
    backEndMarkerList = [];
    visibleDistanceValue = [];
    // backEndHeatMapList: BackEndHeatMap[] = [];
    get backEndHeatMapList() {
        return FictitiousMapModule.UEHotMapData;
    }
    get toolTipsList() {
        return [...this.iconList];
    }
    get paintState() {
        return FictitiousMapModule.paintState;
    }
    get paintData() {
        return FictitiousMapModule.paintData;
    }
    get UEStatusBtn() {
        return FictitiousMapModule.UEStatus;
    }
    get UESilderValue() {
        return FictitiousMapModule.silderValue;
    }
    get storeEventData() {
        return store.eventData;
    }
    get storeEventMap() {
        return store.eventMap;
    }
    backEndHeatMapListChange(val) {
        if (val && val.length > 0) {
            const { radius } = val[0] || {};
            FictitiousMapModule.updataSilderValue(Number(radius));
        }
    }
    UESilderValueChange(val) {
        if (this.backEndHeatMapList.length > 0) {
            this.backEndHeatMapList[0].radius = val;
        }
    }
    mapNameChange() {
        this.onEnd();
    }
    paintStateChange(val) {
        this.interactEnable = val;
    }
    onChangeRootNode(val) {
        this.iconList = [];
        if (val) {
            this.heatMapList = [];
            FictitiousMapModule.clearUEHotMapData();
            FictitiousMapModule.clearPaintData();
            FictitiousMapModule.updataSilderValue(10);
        }
        else {
            this.backEndMarkerList = [];
            this.$emit('update:entranceExitData', initEntranceExitDataConfig());
            this.$emit('changeMarkIcon', initEntranceExitDataConfig());
        }
    }
    onchangePaintData(val) {
        this.heatMapList = val;
    }
    onEventData(nv) {
        this.clear();
        this.eventData = { ...nv };
        if (this.mapType === '3D_UE') {
            this.addEntranceExit(this.eventData);
            if (nv.type === 'icon' && nv.eventKey === 'mark') {
                this.markIconTips();
            }
        }
        else {
            this.dealEventData(this.eventData);
        }
    }
    onEventMap(nv) {
        const { hover } = nv;
        hover && this.dealEventData({ ...hover });
    }
    async onMapImageUrl() {
        if (this.mapType === '2D') {
            this.initIconList();
        }
        if (this.mapType === '3D_UE') {
            await this.visibleDistance();
            this.initUeEntranceExit();
        }
    }
    created() { }
    beforeDestroy() {
        store.updateEventData({});
    }
    async visibleDistance() {
        const resp = await Service.getIconVisibleDistance();
        this.visibleDistanceValue = resp;
    }
    initUeEntranceExit() {
        Object.keys(this.entranceExitData).forEach((item) => {
            const { list = [] } = this.entranceExitData[item] || {};
            list?.forEach((item) => {
                const { position, id, name, dataType } = item || {};
                const entranceExit = {
                    id: id,
                    BuildChooseMode: 'build',
                    range: this.visibleDistanceValue,
                    text: name,
                    tileLayerName: '',
                    styleType: dataType === 'entrance' ? 3 : 5,
                    vertices: position ? Object.values(position) : [],
                };
                this.backEndMarkerList.push(entranceExit);
            });
        });
    }
    mapTypeClick(e, targets, wr) {
        if (this.mapType === '3D_UE') {
            this.backEndClick(e);
        }
        else {
            const { worldPosition, relativePosition } = wr;
            this.mapClick(e, targets, { worldPosition, relativePosition });
        }
    }
    addEntranceExit(e) {
        const { param } = e;
        const { id, dataType } = param || {};
        if (id && this.backEndMarkerList.length > 0) {
            const indexToRemove = this.backEndMarkerList?.findIndex((item) => item.id === id);
            indexToRemove !== -1 && this.backEndMarkerList.splice(indexToRemove, 1);
            if (dataType && this.entranceExitData[dataType]) {
                const { list = [] } = this.entranceExitData[dataType];
                const target = list.find((item) => item.id === id);
                target && this.$set(target, 'position', null);
                this.$emit('update:entranceExitData', this.entranceExitData);
                this.$emit('changeMarkIcon', this.entranceExitData);
            }
        }
    }
    // 初始化回显图标
    initIconList() {
        const nv = this.entranceExitData;
        const icons = [];
        Object.keys(nv).forEach((k) => {
            const val = nv[k];
            const list = val?.list ?? [];
            list?.forEach((item) => {
                icons.push(this.createIcon(item, item.position));
            });
        });
        this.iconList = icons;
    }
    createIcon(info, position) {
        const { id, name, dataType = '' } = info;
        const vueConfig = this.createExitIconVueConfig(id, name, dataType);
        const icon = {
            ...info,
            id: id,
            vertices: position,
            visible: true,
            vueConfig,
        };
        return icon;
    }
    formatPolygons(val) {
        const dom = document.querySelector('#st-virtual-area-box');
        const mapDom = this.$refs.mapEnd;
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        const h = Number(this.styleProp.height) * Scale;
        const w = Number(this.styleProp.width) * Scale;
        let mapPolygons = [];
        if (!isEmpty(val) && w && h) {
            cloneDeep(val).forEach((item) => {
                mapPolygons = item.vertices.map((item) => {
                    const { relativePosition } = mapDom.clientToMapPosition(Number(item.x) * Number(w) + offSetLeft, Number(item.y) * Number(h) + offSetTop);
                    return {
                        x: relativePosition.x,
                        y: relativePosition.y,
                        z: 0,
                    };
                });
            });
        }
        return mapPolygons;
    }
    onStart() {
        // this.progress = 0;
        // this.mapDataloading = true;
        this.$emit('mapDataloading', true);
        FictitiousMapModule.updataHotMapStatus(true);
        this.initIconList();
    }
    // private onProgress(progress: any) {
    //   this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    // }
    onEnd() {
        // this.mapDataloading = false;
        this.$emit('mapDataloading', false);
        FictitiousMapModule.updataHotMapStatus(false);
    }
    onError() {
        this.$emit('mapDataloading', false);
        // this.mapDataloading = false;
        FictitiousMapModule.updataHotMapStatus(false);
    }
    getMapdrawend(data) {
        if (!isEmpty(data)) {
            if (this.mapType === '3D-Three.js') {
                const dom = this.$refs.mapEnd;
                const datalist = [];
                let id = '';
                data?.forEach((item) => {
                    id = item.id;
                    item.vertices?.forEach((vertice) => {
                        vertice.x = vertice.x * 2 - 1;
                        vertice.y = 1 - vertice.y * 2;
                        const itemData = {
                            ...dom.getWorldPosition(vertice),
                        };
                        datalist.push(itemData);
                    });
                });
                const heatMap = [
                    {
                        theme: 'complex',
                        vertices: datalist,
                        id: id,
                    },
                ];
                FictitiousMapModule.updataPaintData(heatMap);
            }
            if (this.mapType === '2D') {
                const roi = this.formatPolygons(data);
                const dataItem = {
                    vertices: roi,
                    id: data[0]?.id,
                    theme: 'complex',
                };
                FictitiousMapModule.updataPaintData([dataItem]);
            }
            let pointDom = this.$refs.simpleDrawer;
            const { id } = data[0];
            if (id && !isEmpty(pointDom)) {
                pointDom.deleteGraph(id);
            }
            pointDom = null;
        }
        FictitiousMapModule.updataPaintState(false);
    }
    dealEventData(nv) {
        const { eventKey } = nv;
        switch (eventKey) {
            case EVENT_KEY['mark']:
                this.dealMark(nv);
                break;
            case EVENT_KEY['removeMark']:
                this.removeMark(nv);
                break;
            case EVENT_KEY['mouseenter']:
                this.hoverIcon(nv, true);
                this.highlightIcon(nv);
                break;
            case EVENT_KEY['mouseleave']:
                this.hoverIcon(nv, false);
                this.highlightIcon(nv);
                break;
        }
    }
    // 高亮图标
    hoverIcon(data, isLighHight) {
        const { id = '', position, dataType = '', name = '' } = data?.param;
        const targetIcon = this.iconList.find((item) => item.id === id);
        if (!position || !targetIcon)
            return;
        const iconType = `${dataType + (isLighHight ? 'LighHight' : '')}`;
        const vueConfig = this.createExitIconVueConfig(id, name, iconType);
        this.$set(targetIcon, 'vueConfig', vueConfig);
    }
    getEntranceExitIconByType(type) {
        return ICON[type] || ICON.entrance;
    }
    createExitIconVueConfig(id, name, iconType) {
        const iconUrl = this.getEntranceExitIconByType(iconType);
        return {
            instance: MapLocationLabel,
            data: {
                title: name,
                isShowTitle: false,
                icon: {
                    id: id,
                    url: iconUrl,
                },
            },
            emitMethods: {
                handleIcon: () => {
                    this.cursor = 'markIcon';
                    // this.changeIconVisble(id, false);
                    this.clearIconPosition(id);
                },
            },
        };
    }
    markIcon(position, info) {
        const { name = '', id = '', dataType } = info;
        const targetIcon = this.iconList.find((item) => item.id === id);
        const vueConfig = this.createExitIconVueConfig((targetIcon?.id ?? id), name, dataType);
        if (targetIcon) {
            targetIcon.visible = true;
            targetIcon.vueConfig = vueConfig;
            targetIcon.vertices = position;
        }
        else {
            const icon = this.createIcon(info, position);
            this.iconList.push(icon);
        }
        this.updateEntranceExitData();
    }
    clearIconPosition(iconId) {
        const targetIcon = this.iconList.find((item) => item.id === iconId);
        if (!targetIcon)
            return;
        targetIcon.visible = false;
        targetIcon.vertices = null;
        this.updateEntranceExitData();
    }
    dealMark({ type, param }) {
        switch (type) {
            case 'icon':
                this.markIconTips();
                this.clearIconPosition(param?.id);
                break;
        }
    }
    markIconTips() {
        this.cursor = 'markIcon';
        this.tips = `${this.$t('markExitTips')}`;
    }
    updateEntranceExitData() {
        const { entrance, exit } = this.entranceExitData;
        const entranceArr = entrance?.list ?? [];
        const exitArr = exit?.list ?? [];
        this.iconList.forEach((icon) => {
            const { dataType, id } = icon;
            if (dataType === 'entrance') {
                const target = entranceArr.find((item) => item.id === id);
                target && this.$set(target, 'position', icon.vertices);
            }
            if (dataType === 'exit') {
                const target = exitArr.find((item) => item.id === id);
                target && this.$set(target, 'position', icon.vertices);
            }
        });
        this.$emit('update:entranceExitData', this.entranceExitData);
        this.$emit('changeMarkIcon', this.entranceExitData);
    }
    clear() {
        this.eventData = {};
        this.cursor = '';
        this.tips = '';
    }
    removeMark({ type, param }) {
        switch (type) {
            case 'icon':
                const id = param?.id;
                this.iconList = this.iconList.filter((item) => item.id !== id);
                break;
        }
    }
    mapClick(target, targets, { worldPosition, relativePosition }) {
        const targetPosition = this.mapType === '3D-Three.js' ? worldPosition : relativePosition;
        const { eventKey, type, param } = this.eventData;
        console.log(eventKey, type, param, 'key');
        if (eventKey) {
            switch (eventKey) {
                case EVENT_KEY['mark']:
                    // 标记图标
                    if (type === 'icon') {
                        param && this.markIcon(targetPosition, param);
                    }
                    break;
            }
        }
        else {
            if (this.cursor === 'markIcon') {
                // 重新标记地图
                this.remarkIcon(targetPosition);
            }
        }
        this.clear();
    }
    backEndClick(e) {
        // 总园区标出入口 反之就画热区
        const { MouseClickPoint = [], eventtype = '', Type = '' } = e;
        if (this.isTotalArea) {
            const { param } = this.eventData;
            const { dataType, id, name } = param || {};
            if (eventtype === 'LeftMouseButtonClick' && Type === 'TileLayer') {
                const entranceExit = {
                    id: id,
                    range: this.visibleDistanceValue,
                    text: name,
                    styleType: dataType === 'entrance' ? 3 : 5,
                    vertices: MouseClickPoint,
                };
                this.backEndMarkerList.push(entranceExit);
                if (dataType && this.entranceExitData[dataType]) {
                    const { list = [] } = this.entranceExitData[dataType];
                    const target = list.find((item) => item.id === id);
                    target && this.$set(target, 'position', MouseClickPoint);
                    this.$emit('update:entranceExitData', this.entranceExitData);
                    this.$emit('changeMarkIcon', this.entranceExitData);
                    this.clear();
                }
            }
        }
        if (this.UEStatusBtn && !this.isTotalArea) {
            const uniqueId = 'heatmap_' + Math.random().toString(36).substring(2, 9);
            const param = {
                id: uniqueId,
                vertices: MouseClickPoint,
                radius: this.UESilderValue,
                rippleNumber: 3,
                color: '#06C6FF',
            };
            FictitiousMapModule.updataUEHotMapData([param]);
        }
    }
    remarkIcon(targetPosition) {
        const icon = this.iconList.find((item) => !item.visible);
        icon && this.markIcon(targetPosition, icon);
    }
    highlightIcon(e) {
        const { param, eventKey } = e;
        const { id, dataType } = param || {};
        const indexToHighlight = this.backEndMarkerList?.findIndex((item) => item.id === id);
        let styleType = 0;
        if (eventKey === 'mouseenter') {
            styleType = dataType === 'entrance' ? 4 : 6;
        }
        if (eventKey === 'mouseleave') {
            styleType = dataType === 'entrance' ? 3 : 5;
        }
        if (indexToHighlight !== -1) {
            const updata = {
                ...this.backEndMarkerList[indexToHighlight],
                styleType: styleType,
            };
            this.backEndMarkerList.splice(indexToHighlight, 1, updata);
        }
    }
};
__decorate([
    Prop()
], DrawMap.prototype, "buttons", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "limits", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "showSelect", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "directionConfig", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "specifiedStyle", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "options", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => {
            return {
                width: 818,
                height: 418,
            };
        },
    })
], DrawMap.prototype, "styleProp", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "mapImageUrl", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "mapType", void 0);
__decorate([
    Prop({ default: false })
], DrawMap.prototype, "loading", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "isRootNode", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "mapName", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "entranceExitData", void 0);
__decorate([
    Prop({ default: true })
], DrawMap.prototype, "isTotalArea", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "mainAngle", void 0);
__decorate([
    Watch('backEndHeatMapList', { deep: true, immediate: true })
], DrawMap.prototype, "backEndHeatMapListChange", null);
__decorate([
    Watch('UESilderValue', { immediate: true })
], DrawMap.prototype, "UESilderValueChange", null);
__decorate([
    Watch('mapName')
], DrawMap.prototype, "mapNameChange", null);
__decorate([
    Watch('paintState')
], DrawMap.prototype, "paintStateChange", null);
__decorate([
    Watch('isRootNode')
], DrawMap.prototype, "onChangeRootNode", null);
__decorate([
    Watch('paintData', { deep: true, immediate: true })
], DrawMap.prototype, "onchangePaintData", null);
__decorate([
    Watch('storeEventData', { deep: true, immediate: true })
], DrawMap.prototype, "onEventData", null);
__decorate([
    Watch('storeEventMap', { deep: true, immediate: true })
], DrawMap.prototype, "onEventMap", null);
__decorate([
    Watch('mapImageUrl', { immediate: true })
], DrawMap.prototype, "onMapImageUrl", null);
DrawMap = __decorate([
    Component({
        name: 'DrawMap',
        components: {
            'st-drawer': Drawer,
            'map-util': mapUtil,
            'st-map-loading': MapLoading,
        },
        i18n: {
            messages: {
                zh: {
                    map: '地图',
                    mapLoading: '地图加载中...',
                    virtualArea: '虚拟区域',
                    markExitTips: '请标记出/入口坐标',
                },
                en: {
                    map: 'Map',
                    mapLoading: 'Map Loading...',
                    virtualArea: 'Virtual Area',
                    markExitTips: 'Click to place the icon',
                },
            },
        },
    })
], DrawMap);
export default DrawMap;
